import { Component, Input, OnInit } from '@angular/core';

import { PurchaseItemMetadataLego } from '../../shared/dto/purchase-item-metadata.lego';

@Component({
  selector: 'wl-purchase-item-lego-summary',
  templateUrl: './purchase-item-lego-summary.component.html',
  styleUrls: ['./purchase-item-lego-summary.component.less'],
    standalone: false
})
export class PurchaseItemLegoSummaryComponent implements OnInit {
  @Input() purchaseItemData: PurchaseItemMetadataLego;
  revenueName = '';
  constructor() {}

  ngOnInit(): void {}
}
